import React from "react"
import PropTypes from "prop-types"
import escapeRegExp from "lodash/escapeRegExp"
import { decodeHtmlCharacters } from "@/utils/helper"

const Highlight = ({ text = "", highlight = "" }) => {
  const normalizedText = decodeHtmlCharacters(text)
  const normalizedHighlight = decodeHtmlCharacters(highlight)

  if (!normalizedHighlight.trim()) return <span>{normalizedText}</span>

  const regex = new RegExp(`(${escapeRegExp(normalizedHighlight)})`, "gi")
  const parts = normalizedText.split(regex)

  return parts
    .filter(part => part)
    .map((part, i) =>
      part.toLowerCase() === normalizedHighlight.toLowerCase() ? (
        <span key={i} className="highlight-text">
          {part}
        </span>
      ) : (
        <span key={i}>{part}</span>
      )
    )
}

Highlight.propTypes = {
  text: PropTypes.string,
  highlight: PropTypes.string,
}

export default Highlight
